import { pubCompanyTypes } from "./pubCompanyTypes";

const INITIAL_STATE = {
  errorMessage: "",
  companyInfo: "",
};

export default (state, action) => {
  if (!state) state = INITIAL_STATE;
  switch (action.type) {
    case pubCompanyTypes.PUB_COMPANY_ONCHANGE:
      return {
        ...state,
        errorMessage: "",
        [action.payload.prop]: action.payload.value,
      };
    default:
      return state;
  }
};
